import React, { useState } from 'react';
import Dashboard from './Dashboard';
import '../css/Campaign.css';

const Campaign = () => {
  const [searchText, setSearchText] = useState('');
  const [activeTab, setActiveTab] = useState('all');
  
  // Empty column and row definitions for the datagrid
  const columns = [
    { field: 'id', headerName: 'ID', width: 70 },
    { field: 'name', headerName: 'Campaign Name', width: 200 },
    { field: 'status', headerName: 'Status', width: 150 },
    { field: 'recipients', headerName: 'Recipients', width: 120 },
    { field: 'created', headerName: 'Created On', width: 150 }
  ];

  // Handle search input change
  const handleSearchChange = (e) => {
    setSearchText(e.target.value);
  };

  // Handle tab change
  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <div className="campaign-container mx-5 mt-5 pt-5">
      <Dashboard />
      <div className="content-area mt-5">
        <div className="campaign-header">
          <h1>Campaigns</h1>
          <button className="btn create-campaign-btn">
            <i className="fas fa-plus me-1"></i> Create Campaign
          </button>
        </div>

        <div className="card campaign-tabs-container">
          <div className="card-header">
            <ul className="nav nav-tabs card-header-tabs">
              <li className="nav-item">
                <button 
                  className={`nav-link ${activeTab === 'all' ? 'active' : ''}`}
                  onClick={() => handleTabChange('all')}
                >
                  All Campaigns
                </button>
              </li>
              <li className="nav-item">
                <button 
                  className={`nav-link ${activeTab === 'active' ? 'active' : ''}`}
                  onClick={() => handleTabChange('active')}
                >
                  Active
                </button>
              </li>
              <li className="nav-item">
                <button 
                  className={`nav-link ${activeTab === 'completed' ? 'active' : ''}`}
                  onClick={() => handleTabChange('completed')}
                >
                  Completed
                </button>
              </li>
              <li className="nav-item">
                <button 
                  className={`nav-link ${activeTab === 'draft' ? 'active' : ''}`}
                  onClick={() => handleTabChange('draft')}
                >
                  Drafts
                </button>
              </li>
            </ul>
          </div>
          <div className="card-body">
          <div className="search-container">
    <div className="input-group" style={{ height: '32px' }}>
      <span className="input-group-text p-0 px-2 d-flex align-items-center" style={{ height: '32px' }}>
        <i className="fas fa-search"></i>
      </span>
      <input 
        type="text" 
        className="form-control py-0" 
        placeholder="Search contacts"
        value={searchText}
        onChange={handleSearchChange}
        style={{ height: '32px' }}
      />
    </div>
  </div>
            
            <div className="table-responsive">
              <table className="table table-hover">
                <thead>
                  <tr>
                    {columns.map((column) => (
                      <th key={column.field}>{column.headerName}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td colSpan={columns.length} className="text-center">
                      <div className="coming-soon-container">
                        <h2 className="coming-soon-text">Coming Soon</h2>
                        <p>WhatsApp Campaign functionality is currently under development.</p>
                        {searchText && (
                          <p className="search-info">You searched for: <strong>{searchText}</strong></p>
                        )}
                        {activeTab !== 'all' && (
                          <p className="filter-info">Filter active: <strong>{activeTab}</strong></p>
                        )}
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Campaign; 